<template>
    <div>
        <modal ref="modal" @close="goBack()" :content-class="'md:mt-16'">
            <alert ref="alert"></alert>

            <div class="flex flex-col w-full h-full bg-purple-900 overflow-y-auto p-16 md:p-20 text-white text-center">

                <div v-if="loading" class="flex w-full h-full items-center justify-center">
                    <div class="loader"></div>
                </div>

                <div v-if="!loading">
                    <h1 class="font-light mb-16">
                        pix
                    </h1>

                    <div v-if="!qrCode">
                        <span class="text-sm">plano</span>

                        <h2 class="text-4xl" v-if="planObj">
                            {{ planObj.name }}
                        </h2>

                        <div class="mt-20 flex flex-col md:flex-row">
                            <div class="w-full mb-5 md:mb-0 md:mr-5">
                                <input type="text" v-model="document_number"
                                       class="w-full h-full input"
                                       name="document_number" placeholder="CPF / CNPJ">
                            </div>

                            <div class="w-full md:w-1/3">
                                <button class="btn btn-orange w-full" @click="generate()">
                                    Pagar
                                </button>
                            </div>
                        </div>
                    </div>

                    <div v-if="qrCode" class="text-center">
                        <div class="pb-5">
                            <p>Escaneie o código PIX abaixo</p>
                        </div>

                        <img class="mx-auto" :src="qrCode" alt="PIX">

                        <div class="pt-5">
                            <p>Ou copie e cole o código PIX abaixo no aplicativo do seu banco</p>
                        </div>

                        <input type="text" id="pixCode" class="input mt-5 w-full" @click="selectText()" readonly v-model="pixCode">

                        <button class="btn btn-orange w-full mt-5" :class="{copied: 'btn-green'}" @click="copy()">
                            <span v-if="!copied">copiar código</span>
                            <span v-if="copied">código PIX copiado!</span>
                        </button>

                        <button class="btn btn-blue w-full mt-5" :disabled="verifying" @click="verify()">
                            <span v-if="!verifying">checar pagamento</span>
                            <span v-if="verifying">identificando pagamento...</span>
                        </button>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>

import {Zapin, Auth} from "@/services/Api";

export default {
    name: 'paymee-pix',

    props: {
        plan: String
    },

    inject: ['alert'],

    mounted() {
        this.$refs.modal.open();

        this.loading = true;

        this.loadPlan()
            .then(() => {
                this.loading = false;
            })
            .then(() => {
                if(this.getUrlParam('checkStatus')) {
                    this.loading = true;
                    this.checkPixStatus();
                }
            });
    },

    data() {
        return {
            planObj: null,
            document_number: null,
            loading: false,
            qrCode: null,
            pixCode: null,
            copied: false,
            verifying: false
        }
    },

    methods: {
        loadPlan() {
            return Zapin
                .plans()
                .show(this.plan)
                .then((res) => {
                    this.planObj = res.data;
                })
        },

        getUrlParam(param) {
            let uri = window.location.search.substring(1);
            let params = new URLSearchParams(uri);

            return params.get(param);
        },

        generate() {
            this.loading = true;

            return Zapin
                .payments()
                .paymee()
                .payPix(this.planObj.slug, this.document_number)
                .then((res) => {
                    this.qrCode = res.data.qrCode.url;
                    this.pixCode = res.data.qrCode.plain;
                })
                .catch(err => {
                    if(err.status === 422) {
                        this.$refs.alert.showValidationErrors(err.data);
                    } else if (err.data.data && err.data.data.message) {
                        this.$refs.alert.show(err.data.data.message);
                    } else {
                        this.$refs.alert.show('Ocorreu um erro desconhecido. Cheque as informações inseridas e se o problema persistir, entre em contato conosco.');
                    }
                })
                .finally(() => this.loading = false);
        },

        checkPixStatus() {
            return Zapin
                .payments()
                .paymee()
                .checkPixStatus()
                .then((res) => {
                    this.qrCode = res.data.pix.url;
                    this.pixCode = res.data.pix.plain;

                    return res;
                })
                .catch(err => {
                    if(err.status === 422) {
                        this.$refs.alert.showValidationErrors(err.data);
                    } else if (err.data.data && err.data.data.message) {
                        this.$refs.alert.show(err.data.data.message);
                    } else {
                        this.$refs.alert.show('Ocorreu um erro desconhecido. Cheque as informações inseridas e se o problema persistir, entre em contato conosco.');
                    }
                })
                .finally((d) => {
                    this.loading = false;
                    return d;
                });
        },

        goBack() {
            Zapin.updateUserData().finally(() => {
                if(Auth.currentUser().hasSubscription()) {
                    this.$router.push('/');
                } else {
                    history.go(-1);
                }
            })
        },

        selectText() {
            let input = document.getElementById('pixCode');

            input.select();
            input.setSelectionRange(0, 99999);

            return input.value;
        },

        copy() {
            let input = document.getElementById('pixCode');

            input.select();
            input.setSelectionRange(0, 99999);

            navigator
                .clipboard
                .writeText(this.pixCode)
                .then(() => {
                    this.copied = true;
                    setTimeout(() => this.copied = false, 5000);
                })
                .catch(() => {
                    this.alert.show('Não foi possível copiar o código PIX automaticamente. Por favor, copie manualmente.');
                });
        },

        verify() {
            this.verifying = true;

            this.checkPixStatus()
                .then(async (res) => {
                    if(res?.data.status === 'PAID') {
                        Zapin.updateUserData().then(() => {
                            this.$router.push('/');
                        })
                    } else {
                        this.$refs.alert.info('Seu pagamento ainda não foi identificado. Aguarde alguns instantes e cheque novamente.');
                        this.verifying = false;
                    }
                })
                .catch(() => this.verifying = false)
        }
    }
}
</script>